import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useSearchParams } from "react-router-dom";

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get("token");
    const errorParam = searchParams.get("error");

    if (errorParam) {
      setError("Authentication failed. Please try again.");
      setLoading(false);
      return;
    }

    if (token) {
      login(token)
        .then(() => {
          // Redirect to game after successful login
          window.location.href = "/";
        })
        .catch((err) => {
          console.error("Login error:", err);
          setError("Failed to complete login. Please try again.");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setError("No authentication token received.");
      setLoading(false);
    }
  }, [searchParams, login]);

  if (loading) {
    return (
      <div className="auth-callback">
        <div className="loading-spinner">Completing login...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-callback">
        <div className="error-message">
          <h2>Login Failed</h2>
          <p>{error}</p>
          <button onClick={() => (window.location.href = "/")}>
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default AuthCallback;
